import { render, staticRenderFns } from "./RegistrationResultsCompetencies.vue?vue&type=template&id=85d9c72c&scoped=true"
import script from "./RegistrationResultsCompetencies.vue?vue&type=script&lang=js"
export * from "./RegistrationResultsCompetencies.vue?vue&type=script&lang=js"
import style0 from "./RegistrationResultsCompetencies.vue?vue&type=style&index=0&id=85d9c72c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d9c72c",
  null
  
)

export default component.exports